import AdminAddDepartmentForm from 'components/form/admin/master/department/AdminAddDepartmentForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AdminAddDepartment extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Department</h4>
                                <AdminAddDepartmentForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
